module.exports = __webpack_public_path__ + "static/media/2.13.1d80422d.png";